import AssessmentSection from "@dta/components/HowToNominate/AssessmentSection";
import DeclarationsSection from "@dta/components/HowToNominate/DeclarationsSection";
import SubmissionsSection from "@dta/components/HowToNominate/SubmissionsSection";
import { TabType } from "@hooks/useTabs";

/**
 * Returns the corresponding static component to render based on the provided active tab identifier.
 *
 * This function is typically used to dynamically render different sections of the
 * Design AI and Tech Awards (DTA) How to Nominate page.
 *
 * @param page - The string identifier of the active tab (e.g., "submissions", "assessment").
 * @returns The React component corresponding to the given page, or `undefined` if not matched.
 */
export const HowToNominateTabsFactory = (tab: TabType) => {
  switch (tab) {
    case "submissionsTab":
      return SubmissionsSection;

    case "assessmentTab":
      return AssessmentSection;

    case "declarationsTab":
      return DeclarationsSection;
  }
};
